<script>
import {useCollectionStore} from "@js/store/CollectionStore.js";
import CatalogProductItem from "@js/components/Sections/Catalog/ProductItem/CatalogProductItem.vue";
import CatalogProductSkeleton from "@js/components/Sections/Catalog/ProductItem/CatalogProductSkeleton.vue";
import {computed} from "vue";

export default {
    name: "CollectionProductList",
    components: {CatalogProductSkeleton, CatalogProductItem},
    setup() {
        const collectionStore = useCollectionStore()

        // Преобразуем products-объект в массив с ключом и заголовком
        const productsByCategory = computed(() => {

            const titleMap = {
                plitka: "Плитка",
                keramogranit: "Керамогранит",
                mozaika: "Мозаика",
                stupeni: "Ступени",
                iskustvenniy_kamen: "Искусственный камень",
                klinker: "Клинкерная плитка"
            }

            return Object.entries(collectionStore.productsByCategory).map(([key, value]) => ({
                key,
                title: titleMap[key] ?? key,
                products: value.products ?? [],
                total: value.total ?? 0
            }));
        });

        return {collectionStore, productsByCategory};
    }
}
</script>

<template>
    <div id="products_list">
        <div v-for="(category, index) in productsByCategory" :key="index" class="category-section">
            <div v-if="category.products.length">
                <h2 class="text-xl md:text-2xl font-semibold mb-3">
                    {{ category.title }} из коллекции «{{ collectionStore.collection.title }}»
                </h2>
                <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5">
                    <CatalogProductItem v-for="(product, key) in category.products"
                                        :data="product" :key="key"/>
                </div>
                <!-- Кнопка "Показать ещё" -->
                <div v-if="category.total > category.products.length" class="mt-5">
                    <button @click="collectionStore.loadMoreProductsByCategory(category.key)"
                            class="bg-baseColor text-black px-5 py-3 rounded-xl text-sm font-semibold uppercase md:hover:bg-baseColor/80">
                        Показать ещё
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
.category-section {
    margin-bottom: 30px;
}
</style>
